import SectionHeading from "@/components/feature/SectionHeading";
import { testimonials } from "@/mocks/testimonials";

export default function HomeVoices() {
  return (
    <section className="w-full bg-background-100 py-14 md:py-20" id="voices">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          eyebrow="Voices"
          title="吃瓜群众怎么说"
          description="每周我们都会翻一遍读者的留言和纠错邮件，这些是其中一部分。"
          align="center"
        />

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {testimonials.map((item) => (
            <figure
              key={item.id}
              className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-5"
            >
              <i className="ri-double-quotes-l text-2xl text-primary-300"></i>
              <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
                {item.quote}
              </blockquote>
              <figcaption className="mt-4 flex items-center gap-3 border-t border-background-200 pt-4">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                  <i className="ri-user-smile-line"></i>
                </span>
                <span>
                  <span className="block text-sm font-medium text-foreground-900">{item.name}</span>
                  <span className="block text-xs text-foreground-500">{item.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}